export default (state) => {
    return state.coverNote;
}



// WEBPACK FOOTER //
// ./src/ReduxRequests/State/coverNoteState.ts